import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PicturesModal } from '../picturesModal';
import { IPicturesVisualizerProps } from './interfaces';

export const PicturesVisualizer = ({ row }: IPicturesVisualizerProps) => {
  const [openPicuturesModal, setOpenPicuturesModal] = useState(false);
  const handleOpenPicturesModal = () => setOpenPicuturesModal(true);
  const handleClosePicturesModal = () => setOpenPicuturesModal(false);

  return (
    <>
      <PicturesModal
        open={openPicuturesModal}
        personId={row.personId}
        returnReceiptId={+row.returnReceiptId}
        handleClose={handleClosePicturesModal}
      />
      <Button className={'classes.buttonDetail'} onClick={() => handleOpenPicturesModal()}>
        <FontAwesomeIcon icon={faEye} size="2x" />
      </Button>
    </>
  );
};
